import type { AddToCartRequest } from '~/types';
import { BaseModel } from '~/models/base-model';

export class AddToCartModel extends BaseModel<AddToCartRequest> {
    qty = 1;
    skuUid = '';
}
